import { render, staticRenderFns } from "./SediDetail.vue?vue&type=template&id=7e0bcc06&"
import script from "./SediDetail.vue?vue&type=script&lang=js&"
export * from "./SediDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Stefano/Desktop/Work/Arco/ArcoProjects/arco_clienti/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VForm,VTextField})
